import { useEffect, useState, lazy, Suspense } from 'react';

//import 'antd/dist/antd.min.css'
import '../styles/PurifiedGlobalAntd.css'
import '../styles/Global.css'
import '../styles/App.css'

import '../styles/EmptyHeaderHero.css'
import '../styles/Footer.css'
import '../styles/GlobalFooter.css'
import '../styles/GlobalHeader.css'
import '../styles/Header.css'
import '../styles/HeaderHero.css'
import '../styles/index.css'
import '../styles/404.css'

import '../styles/Login.css'
import '../styles/EmailUpdate.css'
import '../styles/QSLogin.css'

import { UserContextProvider } from '../src/context'
import { useApiData, ApiDataProvider } from '../src/context/apiContext';
// import Metadata from '../src/components/Metadata';
import GenesysTextWithUs from '../src/components/GenesysTextWithUs';
import { getTestingEnvToken, getHostName, getSiteService, getSiteEnvironment } from '../src/utils/domainUtil';
import { getWebsiteMaintenanceMessage, getWebsiteMaintenanceStatus } from '../src/services';
import { getHolidayPopupMessage, getHolidayPopupStatus, getWebMessageStatus } from '../src/services/Api.js';
import RoundyChatPlaceholder from '../src/components/RoundyChatPlaceholder/RoundyChatPlaceholder';
import Cookies from 'js-cookie';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';

const StickyRoundyChatNow = lazy(() => import("../src/components/StickyRoundyChatNow.js"));

export default function App({ Component, pageProps }) {
  return (
    <ApiDataProvider>
      <AppContent Component={Component} pageProps={pageProps} />
    </ApiDataProvider>
  );
}

function AppContent({ Component, pageProps }) {
  const { websiteStatus, websiteMessage, updateApiData1, updateApiData2, holidayPopupStatus, holidayPopupMessage, webMessageStatus, apiData5 } = useApiData();
  const [hasLoadedWebMessage, setHasLoadedWebMessage] = useState(false)
  const [showWebTool, setShowWebTool] = useState(true)
  const [showGenesysTextWithUs, setShowGenesysTextWithUs] = useState(false)
  const handleShowWebMessage = event => {
    if (!hasLoadedWebMessage) {
      setHasLoadedWebMessage(true);
    }
  };

  if (typeof window === 'object') {
    window.handleShowWebMessage = () => setHasLoadedWebMessage(true)
    window.__WAS_SSR = true
  }

  useEffect(() => {
    if (process.env.NODE_ENV != 'development') {
      if (Cookies.get('CTLE', { domain: '.cure.com' }) != getTestingEnvToken() && getHostName() != 'prod') {
        window.location = "https://www.cure.com";
      }
    }

      if (getSiteEnvironment() === 'Production' && !window.__DATADOG_RUM_INITIALIZED) {
        try {
          datadogRum.init({
            applicationId: '93411452-d0ad-402b-aefa-0e5bcc220167',
            clientToken: 'pub9c4ed5f89f4f746e186fc6665684d0bc',
            site: 'datadoghq.com', // change to us3.datadoghq.com / datadoghq.eu / etc if that’s your region
            service: getSiteService(),
            env: getSiteEnvironment().toLowerCase(),
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'mask-user-input',
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            // plugins: [reactPlugin] // router: true not needed for Next.js
          })
          datadogRum.startSessionReplayRecording()
          window.__DATADOG_RUM_INITIALIZED = true
          window.DD_RUM = datadogRum
        } catch (err) {
          console.error('Datadog RUM init failed', err)
        }
      }

    // Retrieves maintenance status and message from server
    const fetchData = async () => {
      try {
        const websiteStatusResponse = await getWebsiteMaintenanceStatus();
        const websiteMessageResponse = await getWebsiteMaintenanceMessage();
        const holidayPopupStatusResponse = await getHolidayPopupStatus();
        const holidayPopupMessageResponse = await getHolidayPopupMessage();
        const webMessageResponse = await getWebMessageStatus();

        websiteStatus(websiteStatusResponse);
        websiteMessage(websiteMessageResponse);
        holidayPopupStatus(holidayPopupStatusResponse);
        holidayPopupMessage(holidayPopupMessageResponse);
        webMessageStatus(webMessageResponse);
      } catch (error) {
        console.error('Error fetching data: ', error);
      }
    };

    fetchData();
  }, [])

  return (
    <div className="cure-main-container">
      {/* <Nav /> */}
      {/* <Metadata /> */}
      <div className="wrapper" style={{ position: "relative" }}>
        <UserContextProvider>
          <Component {...pageProps} />
        </UserContextProvider>

        {(!hasLoadedWebMessage) && (
          <RoundyChatPlaceholder
            setShowGenesysTextWithUs={setShowGenesysTextWithUs}
            handleShowMessagingTool={handleShowWebMessage}
            show={showWebTool}
            setShow={setShowWebTool}
            webMessageStatus={apiData5?.data?.Result}
          />
        )}
        <GenesysTextWithUs show={showGenesysTextWithUs} setShow={setShowGenesysTextWithUs} setShowWebTool={setShowWebTool} handleShowMessagingTool={handleShowWebMessage} />
        <Suspense fallback={<div></div>}>
          {
            hasLoadedWebMessage ?
              <StickyRoundyChatNow setShowGenesysTextWithUs={setShowGenesysTextWithUs} /> :
              null
          }
        </Suspense>
      </div>
    </div>
  )
}